import React from "react";
import {SvgIcon, SvgIconProps} from "@mui/material";

const IronButterflySvg = (props: any) => (<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <path d="M1.02042 1V33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1 18.0225H33" stroke="#88888866" strokeOpacity="0.4" strokeLinecap="round" strokeDasharray="5 5"/>
        <path d="M1.02042 25.0535H10.3821L12.3073 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M31.1188 25.0535H21.7572L19.8319 18.0225" stroke="#A40C0C" strokeWidth="2"/>
        <path d="M12.3073 18.0225L15.932 3.96043L19.8319 18.0225" stroke="#089981" strokeWidth="2"/>
    </svg>
)

const IronButterfly: React.FC<SvgIconProps> = React.memo((props) => (
    <SvgIcon {...props}>
        {IronButterflySvg(props)}
    </SvgIcon>
));
export default IronButterfly